// src/components/ToolsPage.jsx
import React, { useEffect, useState } from "react";
import companyLogo from "../assets/aei-logo.jpg";
import { useAuth } from "../auth/AuthContext";
import heroBg from "../assets/hero-bg.jpg";
import structuralThumb from "../assets/structural-thumb.JPG";
import pmThumb from "../assets/pm-thumb.jpg";
import toolsRightBg from "../assets/tools-right-bg.png";
import toolsSidebarSketch from "../assets/tools-sidebar-sketch.png";
import sap2000Thumb from "../assets/sap2000-thumbnail.jpg";
const PINNED_KEY = "aei_pinned_tools";

const TOOLS = [

    {
    id: "sap2000",
    name: "AEI Force Extractor",
    version: "v1.1.1",
    desc: "Open the AEI Structural Helper plugin for SAP2000 and ETABS force extraction, result processing, and Excel export.",
    icon: "🏗️",
    thumbnail: sap2000Thumb,
    iconClass: "ic-blue",
    tags: [
      { label: "Structural", cls: "tag-blue" },
      { label: "SAP2000", cls: "tag-blue" },
      { label: "ETABS", cls: "tag-blue" },
    ],
    category: "structural",
    btnClass: "btn-blue",
  },
  {
    id: "stripforces",
    name: "Strip Forces Tool",
    version: "v2.0",
    desc: "Upload ETABS strip forces, filter by story / strip / case and generate M3 & V2 diagrams.",
    icon: "📊",
    thumbnail: structuralThumb,
    iconClass: "ic-blue",
    tags: [
      { label: "Structural", cls: "tag-blue" },
      { label: "ETABS", cls: "tag-blue" },
    ],
    category: "structural",
    btnClass: "btn-blue",
  },
  {
    id: "ptt",
    name: "Project Time Tracker",
    version: "v2.0",
    desc: "Track project hours, manage tasks, view PM and executive dashboards, and generate monthly reports.",
    icon: "🕐",
    thumbnail: pmThumb,
    iconClass: "ic-teal",
    tags: [{ label: "Project Management", cls: "tag-teal" }],
    category: "pm",
    btnClass: "btn-teal",
  },
];

export default function ToolsPage({
  onOpenStripforces,
  onOpenTimeTracker,
  onOpenSap2000,
  onLogout,
}) {
  const { auth } = useAuth();
  const user = auth?.user;
  const displayName = user?.username || user?.email || user?.name || "User";

  const [pinned, setPinned] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(PINNED_KEY) || "[]");
    } catch {
      return [];
    }
  });

  const [search, setSearch] = useState("");
  const [activeView, setActiveView] = useState("pinned");

  useEffect(() => {
    localStorage.setItem(PINNED_KEY, JSON.stringify(pinned));
  }, [pinned]);

  const togglePin = (id) =>
    setPinned((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );

 const openTool = (id) => {
  if (id === "sap2000") onOpenSap2000();
  if (id === "stripforces") onOpenStripforces();
  if (id === "ptt") onOpenTimeTracker();
};

  const filterFn = (t) => {
    const q = search.toLowerCase().trim();
    return !q || t.name.toLowerCase().includes(q) || t.desc.toLowerCase().includes(q);
  };

  const handleSearch = (value) => {
    setSearch(value);
    if (value.trim() && activeView === "pinned") setActiveView("all");
  };

  const handleNav = (view) => {
    setActiveView(view);
    setSearch("");
  };

  const pinnedTools = TOOLS.filter((t) => pinned.includes(t.id) && filterFn(t));
  const structuralTools = TOOLS.filter(
    (t) => t.category === "structural" && filterFn(t)
  );
  const pmTools = TOOLS.filter((t) => t.category === "pm" && filterFn(t));

  const showPinned = activeView === "pinned" || activeView === "all";
  const showAll =
    activeView === "all" ||
    activeView === "structural" ||
    activeView === "pm";
  const showStructural = activeView !== "pm";
  const showPM = activeView !== "structural";

  const renderCard = (t) => {
    const isPinned = pinned.includes(t.id);

    return (
      <div key={t.id} className="portal-card portal-card--with-image">
        <button
          className={`portal-pin-btn${isPinned ? " pinned" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            togglePin(t.id);
          }}
          title={isPinned ? "Unpin" : "Pin"}
        >
          {isPinned ? "📌" : "📍"}
        </button>

        <div className="portal-card-thumb">
          <img
            src={t.thumbnail}
            alt={`${t.name} preview`}
            className="portal-card-thumb-img"
          />
        </div>

        <div className="portal-card-name">{t.name}</div>
        <div className="portal-card-ver">{t.version}</div>
        <div className="portal-card-desc">{t.desc}</div>

        <div className="portal-card-tags">
          {t.tags.map((tg) => (
            <span key={tg.label} className={`portal-tag ${tg.cls}`}>
              {tg.label}
            </span>
          ))}
        </div>

        <button
          className={`portal-open-btn ${t.btnClass}`}
          onClick={() => openTool(t.id)}
        >
          Open →
        </button>
      </div>
    );
  };

  return (
    <div className="app-shell">
      <style>{`
        .portal-body {
          position: relative;
        }
.portal-sidebar {
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(
      180deg,
      #03111d 0%,
      #061826 45%,
      #0a1c29 100%
    );
  border-right: 1px solid rgba(120, 240, 255, 0.08);
}

.portal-sidebar::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(
      circle at 20% 14%,
      rgba(20, 184, 166, 0.08) 0%,
      rgba(20, 184, 166, 0.03) 18%,
      rgba(20, 184, 166, 0) 42%
    );
  z-index: 0;
}

.portal-sidebar::after {
  content: "";
  position: absolute;
  left: -8px;
  bottom: 10px;
  width: 185px;
  height: 230px;
  pointer-events: none;
  opacity: 0.22;
  z-index: 0;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: left bottom;
  background-image: url("data:image/svg+xml;utf8,\
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 220 260' fill='none'>\
<g stroke='rgba(120,240,255,0.55)' stroke-width='1.4'>\
<path d='M25 235 L85 200 L145 235 L85 260 Z'/>\
<path d='M85 200 L85 125'/>\
<path d='M145 235 L145 160'/>\
<path d='M45 222 L45 175 L85 150 L125 175 L125 222'/>\
<path d='M45 175 L125 175'/>\
<path d='M18 248 L205 248'/>\
</g>\
</svg>");
}

.portal-sidebar > * {
  position: relative;
  z-index: 1;
}

.portal-content {
  position: relative;
  overflow: hidden;
  padding-right: 28px;
}

.portal-content--themed {
  min-height: calc(100vh - 110px);
  background:
    linear-gradient(
      90deg,
      #2f343d 0%,
      #2f343d 40%,
      #0d1f2c 70%,
      #0a2732 100%
    );
}

  .app-shell {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    background:
      linear-gradient(90deg, #0f1720 0%, #1e2936 26%, #24303f 44%, #0b2230 72%, #06232c 100%);
  }

  .portal-body {
    position: relative;
    min-height: calc(100vh - 110px);
  }

  .portal-sidebar {
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(
      180deg,
      #07131d 0%,
      #04101a 38%,
      #03111b 100%
    );
  border-right: 1px solid rgba(120, 240, 255, 0.08);
}

.portal-sidebar::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(
      circle at 20% 12%,
      rgba(0, 200, 200, 0.08) 0%,
      rgba(0, 200, 200, 0.03) 18%,
      transparent 42%
    ),
    linear-gradient(
      180deg,
      rgba(0, 120, 160, 0.02) 0%,
      transparent 32%
    );
  z-index: 0;
}

.portal-sidebar::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 92px;
  width: 100%;
  height: 44%;
  background: url("${toolsSidebarSketch}") no-repeat center bottom;
  background-size: cover;
  opacity: 0.18

  pointer-events: none;
  z-index: 0;
  mix-blend-mode: screen;
  filter: brightness(0.92) saturate(0.9);
  mask-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0.92) 18%,
    rgba(0, 0, 0, 0.55) 52%,
    rgba(0, 0, 0, 0) 100%
  );
  -webkit-mask-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0.92) 18%,
    rgba(0, 0, 0, 0.55) 52%,
    rgba(0, 0, 0, 0) 100%
  );
}

.portal-sidebar > * {
  position: relative;
  z-index: 1;
}

.sb-bottom {
  margin-top: auto;
  position: relative;
  z-index: 2;
}

  .portal-content {
    position: relative;
    z-index: 1;
    overflow: hidden;
    padding-right: 28px;
  }

.portal-content--themed {
  position: relative;
  min-height: calc(100vh - 110px);
  background:
    radial-gradient(circle at 82% 42%, rgba(0, 200, 200, 0.12), transparent 34%),
    radial-gradient(circle at 72% 78%, rgba(0, 140, 180, 0.06), transparent 28%),
    linear-gradient(90deg, #2f343d 0%, #303743 40%, #122632 68%, #07242d 100%);
}

 .portal-content--themed::after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 68%;
  height: 100%;
  background: url("${toolsRightBg}") no-repeat right center;
  background-size: cover;
  opacity: 0.18
  pointer-events: none;
  z-index: 0;
  mix-blend-mode: screen;

  mask-image: linear-gradient(
    90deg,
    transparent 0%,
    rgba(0, 0, 0, 0.06) 18%,
    rgba(0, 0, 0, 0.35) 34%,
    rgba(0, 0, 0, 0.8) 58%,
    rgba(0, 0, 0, 1) 100%
  );
  -webkit-mask-image: linear-gradient(
    90deg,
    transparent 0%,
    rgba(0, 0, 0, 0.06) 18%,
    rgba(0, 0, 0, 0.35) 34%,
    rgba(0, 0, 0, 0.8) 58%,
    rgba(0, 0, 0, 1) 100%
  );
}

  .portal-content--themed > * {
    position: relative;
    z-index: 2;
  }
       
        .portal-banner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 18px;
          overflow: hidden;
          width: min(100%, 900px);
          min-height: 160px;
          padding: 16px 20px;
          border-radius: 18px;
        }

        .portal-banner-body {
          flex: 1 1 auto;
          min-width: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .portal-banner-tag {
          font-size: 0.72rem;
          margin-bottom: 6px;
          opacity: 0.9;
        }

        .portal-banner-title {
          font-size: 1.55rem;
          line-height: 1.08;
          margin-bottom: 8px;
        }

        .portal-banner-desc {
          max-width: 320px;
          line-height: 1.4;
          margin-top: 2px;
          margin-bottom: 2px;
          font-size: 0.95rem;
        }

        .portal-banner-row {
          margin-top: 12px;
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }

        .portal-banner-chip {
          font-size: 0.72rem;
          padding: 5px 10px;
        }

        .portal-banner-btn {
          padding: 8px 16px;
          font-size: 0.9rem;
        }

        .portal-banner-preview {
          flex: 0 0 250px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .portal-banner-preview img {
          width: 100%;
          height: 120px;
          object-fit: cover;
          border-radius: 14px;
          border: 1px solid rgba(255,255,255,0.12);
          box-shadow: 0 8px 18px rgba(0,0,0,0.16);
          display: block;
        }

        .portal-search-wrap {
          width: min(100%, 900px);
          margin-top: 18px;
          margin-bottom: 14px;
        }

        .portal-search-box {
          width: min(100%, 460px);
        }

        .portal-section {
          width: min(100%, 1050px);
        }

        .portal-card--with-image {
          position: relative;
          overflow: visible;
          min-height: 285px;
          transition: transform 0.18s ease, box-shadow 0.18s ease;
        }

        .portal-card--with-image:hover {
          transform: translateY(-4px);
          box-shadow: 0 14px 28px rgba(0,0,0,0.22);
        }

        .portal-pin-btn {
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 20;
        }

        .portal-card-thumb {
          position: relative;
          width: 100%;
          height: 128px;
          border-radius: 12px;
          overflow: hidden;
          margin-bottom: 12px;
          background: rgba(255,255,255,0.04);
          z-index: 1;
        }

        .portal-card-thumb-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .portal-card-name {
          margin-top: 2px;
        }

        .portal-card-desc {
          line-height: 1.45;
        }

        .portal-cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 320px));
          gap: 22px;
          align-items: start;
        }

        @media (max-width: 980px) {
.portal-content--themed::after {
  width: 110%;
  right: -160px;
  top: 90px;
  opacity: 0.10;
  background-size: cover;
}

.portal-sidebar::after {
  width: 100%;
  height: 34%;
  left: 0;
  bottom: 78px;
  opacity: 0.14;
  background-size: cover;
}
          .portal-banner {
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
            min-height: unset;
            padding: 16px;
          }

          .portal-banner-preview {
            flex: 1 1 auto;
            width: 100%;
          }

          .portal-banner-preview img {
            height: 170px;
          }

          .portal-search-wrap,
          .portal-section {
            width: 100%;
          }

          .portal-search-box {
            width: 100%;
          }

          .portal-cards-grid {
            grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          }

            .portal-bg-illustration {
    width: 92%;
    right: -120px;
    top: 120px;
    opacity: 0.14;
  }

  .portal-bg-grid {
    opacity: 0.05;
  }

  .portal-sidebar::after {
    width: 110px;
    height: 140px;
    opacity: 0.10;
    left: -12px;
    bottom: 6px;
  }
        }
      `}</style>

      <header className="tools-header">
        <div className="tools-header-left">
          <img
            src={companyLogo}
            alt="AEI Progetti"
            className="tools-header-logo"
            width="180"
            height="60"
          />
          <div>
            <div className="tools-header-company">AEI PROGETTI SRL</div>
            <div className="tools-header-tagline">Engineering Software Suite</div>
          </div>
        </div>

        <div className="tools-header-right">
          {user && (
            <div className="tools-user-info">
              Logged in as {displayName} ({user.role})
            </div>
          )}
          <button
            type="button"
            className="tools-logout-button"
            onClick={onLogout}
          >
            Logout
          </button>
        </div>
      </header>

      <div className="portal-body">
        <aside className="portal-sidebar">
          <div className="sb-ptt-btn" onClick={onOpenTimeTracker}>
            <div className="sb-ptt-label">Daily Tool</div>
            <div className="sb-ptt-name">
              🕐 Time Tracker <span className="sb-ptt-arrow">↗</span>
            </div>
          </div>

          <hr className="sb-divider" />

          <div className="sb-section">
            <div className="sb-label">Navigation</div>

            <div
              className={`portal-nav-item${activeView === "pinned" ? " active" : ""}`}
              onClick={() => handleNav("pinned")}
            >
              <span className="nav-icon">📌</span> Pinned
            </div>

            <div
              className={`portal-nav-item${activeView === "all" ? " active" : ""}`}
              onClick={() => handleNav("all")}
            >
              <span className="nav-icon">⊞</span> All Tools
            </div>
          </div>

          <div className="sb-section">
            <div className="sb-label">Categories</div>

            <div
              className={`portal-nav-item${activeView === "structural" ? " active" : ""}`}
              onClick={() => handleNav("structural")}
            >
              <span className="nav-icon">🏗</span> Structural
            </div>

            <div
              className={`portal-nav-item${activeView === "pm" ? " active" : ""}`}
              onClick={() => handleNav("pm")}
            >
              <span className="nav-icon">📋</span> Project Management
            </div>
          </div>

          <div className="sb-bottom">
            <div className="sb-brand">
              <img src={companyLogo} alt="AEI" className="sb-brand-logo-img" />
              <div>
                <div className="sb-brand-name">AEI PROGETTI SRL</div>
                <div className="sb-brand-sub">Engineering Tools</div>
              </div>
            </div>
          </div>
        </aside>

        <main className="portal-content portal-content--themed">
          
          <div className="portal-banner" onClick={onOpenTimeTracker}>
            <div className="portal-banner-icon">🕐</div>

            <div className="portal-banner-body">
              <div className="portal-banner-tag">
                Daily Tool · Project Management
              </div>

              <div className="portal-banner-title">Project Time Tracker</div>

              <div className="portal-banner-desc">
                Log hours, manage tasks, view dashboards and generate reports.
              </div>

              <div className="portal-banner-row">
                <span className="portal-banner-chip">Time Logging</span>
                <span className="portal-banner-chip">Dashboards</span>
                <span className="portal-banner-chip">Reports</span>

                <button
                  className="portal-banner-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    onOpenTimeTracker();
                  }}
                >
                  Open →
                </button>
              </div>
            </div>

            <div className="portal-banner-preview">
              <img src={heroBg} alt="Project Time Tracker preview" />
            </div>
          </div>

          <div className="portal-search-wrap">
            <div className="portal-search-box">
              <span className="portal-search-icon">🔍</span>
              <input
                type="text"
                placeholder="Search tools..."
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          </div>

          {showPinned && (
            <div className="portal-section">
              <div className="portal-section-row">
                <span className="portal-section-title">📌 Pinned</span>
                <span className="portal-section-count">{pinnedTools.length}</span>
              </div>

              {pinnedTools.length > 0 ? (
                <div className="portal-cards-grid">
                  {pinnedTools.map(renderCard)}
                </div>
              ) : (
                <div className="portal-empty">
                  <div className="portal-empty-icon">📌</div>
                  <div className="portal-empty-title">No pinned tools</div>
                  <div className="portal-empty-sub">
                    Click 📍 on any card below to pin it here
                  </div>
                </div>
              )}
            </div>
          )}

          {activeView === "all" && <hr className="portal-divider" />}

          {showAll && (
            <div className="portal-section">
              {activeView === "all" && (
                <div
                  className="portal-section-title"
                  style={{ marginBottom: 16 }}
                >
                  ⊞ All Tools
                </div>
              )}

              {showStructural && structuralTools.length > 0 && (
                <div>
                  <div className="portal-section-sub">Structural Engineering</div>
                  <div className="portal-cards-grid">
                    {structuralTools.map(renderCard)}
                  </div>
                </div>
              )}

              {showPM && pmTools.length > 0 && (
                <div>
                  <div className="portal-section-sub">Project Management</div>
                  <div className="portal-cards-grid">
                    {pmTools.map(renderCard)}
                  </div>
                </div>
              )}

              {search && !structuralTools.length && !pmTools.length && (
                <div className="portal-no-results">
                  🔍 No tools match "{search}"
                </div>
              )}
            </div>
          )}
        </main>
      </div>

      <footer className="site-footer">
        <div className="site-footer-inner">
          <div className="site-footer-section site-footer-logo">
            <img src={companyLogo} alt="AEI Progetti" />
            <div>
              <strong>AEI PROGETTI SRL</strong>
              <br />
              Via Bolognese 48
              <br />
              50139 Firenze, Italy
            </div>
          </div>

          <div className="site-footer-section">
            <div>Phone: +39 055 400714</div>
            <div>Fax: +39 055 461079</div>
          </div>

          <div className="site-footer-section">
            <div>Email: mail@aeiprogetti.it</div>
            <div>PEC: mail@pec.aeiprogetti.it</div>
          </div>
        </div>
      </footer>
    </div>
  );
}
